import React, { memo } from 'react';
import { RichMarkdown } from '../markdown';
import styles from './structuredResponse.module.css';

function BlockMarkdown({
    content,
    citations = [],
    chunks = [],
    citationScope = '',
    onCitationClick,
    className = '',
}) {
    const text = String(content || '').trim();
    if (!text) return null;
    return (
        <RichMarkdown
            content={text}
            citations={citations}
            chunks={chunks}
            citationScope={citationScope}
            onCitationClick={onCitationClick}
            className={`${styles.blockMarkdown} ${className}`.trim()}
        />
    );
}

export default memo(BlockMarkdown);
